import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories } from '@/mocks/categories';
import { getHotArticles, getLatestArticles } from '@/mocks/articles';
import { faqItems } from '@/mocks/about';

export default function HomePage() {
  const hotArticles = getHotArticles();
  const latestArticles = getLatestArticles(8);
  const heroArticle = hotArticles[0];

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '爆料网',
    url: 'https://baoliaowang.com',
    description: '爆料网汇聚全网最新独家爆料内容，涵盖娱乐圈内幕、社会热点、商业秘闻等多领域爆料资讯。',
    inLanguage: 'zh-CN',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爆料网',
    url: 'https://baoliaowang.com',
    description: '第一手独家爆料资讯平台',
    email: 'tips@baoliaowang.com',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'tips@baoliaowang.com',
      availableLanguage: ['Chinese'],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <SEOHead
        title="爆料网 - 第一手独家爆料资讯平台"
        description="爆料网汇聚全网最新独家爆料内容，涵盖娱乐圈内幕、社会热点、商业秘闻等多领域爆料资讯。第一时间获取真实可信的爆料信息，关注爆料网，掌握你不知道的内幕真相。"
        keywords="爆料网,独家爆料,娱乐爆料,社会爆料,内幕资讯,热点爆料,匿名爆料投稿"
        canonicalUrl="https://baoliaowang.com"
      />
      <SchemaOrg schema={websiteSchema} />
      <SchemaOrg schema={orgSchema} />
      <SchemaOrg schema={faqSchema} />

      <main>
        <section className="relative w-full min-h-[580px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=dramatic%20newsroom%20atmosphere%20with%20abstract%20geometric%20shapes%20warm%20dark%20red%20and%20amber%20gradients%20breaking%20news%20theme%20modern%20journalism%20aesthetic%20cinematic%20dramatic%20lighting%20bold%20typography%20vibe%20editorial%20design%20style&width=1600&height=900&seq=home-hero-bg&orientation=landscape"
              alt="爆料网"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
            <p className="text-accent-400 text-sm md:text-base font-medium tracking-widest mb-4 animate-fade-in">
              第一手独家爆料资讯平台
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
              掌控<strong className="text-primary-400">内幕真相</strong>
              <br />
              从这里开始
            </h1>
            <p className="text-secondary-200 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
              娱乐圈内幕、社会热点追踪、商业秘闻揭露、科技行业洞察 ——
              爆料网为你呈现事件背后的真实面貌
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to={`/article/${heroArticle.id}`}
                className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                查看今日重磅爆料
              </Link>
              <Link
                to="/category/yule-baoliao"
                className="px-8 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 backdrop-blur-sm font-semibold rounded-lg border border-background-50/20 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                浏览全部分类
              </Link>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-10">
              <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                热点爆料
              </h2>
              <span className="px-2.5 py-0.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full">
                HOT
              </span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {hotArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-10">
              <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                内容分类
              </h2>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex flex-col items-center gap-3 p-6 bg-background-50 rounded-lg hover:bg-background-100 transition-colors cursor-pointer group"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-colors">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{cat.name}</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-10">
              <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                最新爆料
              </h2>
            </div>
            <div className="flex flex-col gap-5">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} variant="horizontal" />
              ))}
            </div>
            <div className="text-center mt-10">
              <Link
                to="/category/yule-baoliao"
                className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-100 hover:bg-secondary-200 text-foreground-800 font-medium rounded-lg transition-colors cursor-pointer text-sm"
              >
                查看更多爆料
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-10">
              <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                常见问题
              </h2>
            </div>
            <div className="space-y-3">
              {faqItems.map((faq, idx) => (
                <details key={idx} className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer">
                  <summary className="flex items-center justify-between p-5 text-foreground-900 font-medium text-sm list-none">
                    {faq.question}
                    <i className="ri-add-line group-open:hidden text-foreground-500"></i>
                    <i className="ri-subtract-line hidden group-open:block text-primary-500"></i>
                  </summary>
                  <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-secondary-900">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
              你有爆料？我们倾听
            </h2>
            <p className="text-secondary-300 mb-8 text-sm md:text-base leading-relaxed">
              如果你掌握任何领域的内幕信息，欢迎匿名向我们投稿。我们建立了严格的信息源保护机制，确保每一位爆料人的安全和隐私。
            </p>
            <a
              href="mailto:tips@baoliaowang.com"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-mail-send-line"></i>
              立即投稿
            </a>
          </div>
        </section>
      </main>
    </>
  );
}